import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, BellRinging } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

/* Bell button — opens the dedicated /notifications screen. Keeps a live unread badge. */
export default function NotificationBell() {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);
  const navigate = useNavigate();

  async function loadCount() {
    if (!user) return;
    try { const { data } = await api.get("/api/notifications?limit=1"); setUnread(data.unread || 0); } catch {}
  }
  useEffect(() => { loadCount(); const id = setInterval(loadCount, 25000); return () => clearInterval(id); /* eslint-disable-next-line */ }, [user?.id]);

  return (
    <button data-testid="notification-bell" onClick={() => navigate("/notifications")}
      className="relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.05] text-white/85 transition hover:text-white">
      {unread > 0 ? <BellRinging size={18} weight="fill" className="text-neon-cyan" /> : <Bell size={18} weight="bold" />}
      {unread > 0 && (
        <span data-testid="notification-badge" className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-neon-pink px-1 text-[10px] font-extrabold text-white shadow-glow-pink">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
